import { render } from "./ResetPassword.vue?vue&type=template&id=1e86d05c"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=1e86d05c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__